import React from "react";

const Home = () => (
  <div>
    <h2>Global.Bible</h2>
  </div>
);

export default Home;
